import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

// Password recovery — matches the Login screen visual (backdrop image, warm surface, brand chip).
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      // Neutral confirmation — same whether the email exists or not.
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err) || "Не удалось отправить письмо");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" data-testid="forgot-password-page">
      <div
        className="flex-1 flex items-end"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(74,59,50,0.10) 0%, rgba(74,59,50,0.55) 100%), url('https://customer-assets-rejwkqb3.emergentagent.net/job_4fdfd6f9-6803-4276-8258-f36ae827b1f3/artifacts/pntpjlxa_79B8E46A-C20C-47B8-AD98-722E2F90A324.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="w-full bg-white rounded-t-[32px] px-7 pt-9 pb-10 shadow-[0_-12px_40px_rgba(0,0,0,0.15)]">
          <div className="mb-7">
            <div className="chip bg-sand/60 text-espresso inline-block mb-3">Anokina Studio</div>
            <h1 className="font-serif text-4xl leading-tight text-espresso" data-testid="forgot-title">
              Восстановление<br />пароля
            </h1>
            <p className="text-sm text-muted-foreground mt-2">
              Введите email, привязанный к аккаунту — мы пришлём одноразовую ссылку для сброса пароля.
            </p>
          </div>

          {sent ? (
            <div className="space-y-5" data-testid="forgot-sent-state">
              <div className="rounded-2xl bg-sand/40 border border-sand text-espresso px-4 py-4 text-sm leading-relaxed">
                Если такой email зарегистрирован — мы отправили письмо со ссылкой для восстановления пароля. Проверьте входящие и папку «Спам».
                <br />
                Ссылка действительна 30&nbsp;минут и может быть использована один раз.
              </div>
              <Link
                to="/login"
                data-testid="forgot-back-to-login"
                className="btn-pill w-full h-12 bg-espresso hover:bg-espressoDark text-white text-base inline-flex items-center justify-center"
              >
                Вернуться ко входу
              </Link>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <label className="text-xs uppercase tracking-widest text-muted-foreground">Email</label>
                <Input
                  data-testid="forgot-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-1 h-12 rounded-xl"
                />
              </div>
              <Button
                data-testid="forgot-submit-button"
                type="submit"
                disabled={loading}
                className="btn-pill w-full h-12 bg-espresso hover:bg-espressoDark text-white text-base"
              >
                {loading ? "Отправляем…" : "Отправить ссылку"}
              </Button>
              <div className="text-center">
                <Link
                  data-testid="forgot-back-link"
                  to="/login"
                  className="text-xs uppercase tracking-widest text-espresso/70 hover:text-espresso underline underline-offset-4"
                >
                  Вернуться ко входу
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
